module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAZCAYAAADJ9/UkAAAAAXNSR0IArs4c6QAAAU5JREFUSEvtlq1Ww1AQhGccEolEIiuRSCSPwGMgeQQeAYlEIiMrkZWVSCRuOR8ny7nNSdM0PwTRq3qae2dmZ+du4og4k3Qr6UoSv+den5LebG8cEXeSVnMztuA/Qf64ADGU1b8h/5C0rVswR+8T/7p2eqfyZ9vbiDiXdDNhDr7qgL1DGhH3ki6btqPsxTZpZBMbuAUXIzJRSVrbRgCYBBtMnG3tedeBvjpo32ujENykoFx7A0f1le20CqX0CoCuxTlIIafSnCFtV/lg2gFBRIKRhxxIpQhsZd86/4wIhCJ4X3gPkicWDgBe5oHhhBgIeZZ9ZVIikGddqzc5IIATHjLxs7gZhSCCCWnZ18nIE+h3Nhd9TYv7BpJ9R1XeBCYHXE/CNGQojSI/psq2vSfysQ4OOn+yfZBtYw8tb/vDwCExSeWLfr3+9Xc7I5m34OYbmJjKNQyH6NoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/footer-email.png
// module id = AWnl
// module chunks = 2